import { render } from "./FooterPCZ.vue?vue&type=template&id=50b18666"
import script from "./FooterPCZ.vue?vue&type=script&lang=js"
export * from "./FooterPCZ.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/hypergen.be/pcz.hypergen.be/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__